export default __webpack_public_path__ + "static/media/19.ac12a720.mp3";